import { Trans, msg } from '@lingui/macro'
import { Model } from 'jms-domain'

import {
  AttributeListSelector,
  AttributeSwitchSelector,
  useResolveLocalizable,
} from '@salsita-ai/platform-project-sdk/react'
import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

const powderCoatingTitle = msg({ message: 'Powder Coating' })
const powderCoatingDescription = msg({ message: 'Match front panel cover with cabinets' })

export const BurnerBasePropertyPage = (props: { id: Model.BurnerBase['id']; applianceId: Model.Appliance['id'] }) => {
  const { id, applianceId } = props
  const isApplianceWithPowderCoating = applianceId && Model.ApplianceWithPowderCoating.isId(applianceId)

  const resolveLocalizable = useResolveLocalizable()

  return (
    <PropertyContainer.Group spacing="large">
      {isApplianceWithPowderCoating && (
        <PropertyContainer.Item>
          <AttributeSwitchSelector
            entityId={applianceId}
            instanceName="powderCoating"
            title={resolveLocalizable(powderCoatingTitle)}
            description={resolveLocalizable(powderCoatingDescription)}
          />
        </PropertyContainer.Item>
      )}

      {Model.LynxProfessionalPowerBurner.isId(applianceId) && (
        <PropertyContainer.Item title={<Trans>Variant</Trans>}>
          <AttributeListSelector entityId={id} instanceName="variant" />
        </PropertyContainer.Item>
      )}
    </PropertyContainer.Group>
  )
}
